import { render, staticRenderFns } from "./editform.vue?vue&type=template&id=10a8c2d4&scoped=true&"
import script from "./editform.vue?vue&type=script&lang=js&"
export * from "./editform.vue?vue&type=script&lang=js&"
import style0 from "./editform.vue?vue&type=style&index=0&id=10a8c2d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a8c2d4",
  null
  
)

export default component.exports